import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";
import { Settings, Users, Package } from "lucide-react";

export default function ModalNavigation() {
    const {
        shortcodeFormData: formData,
        shortcodeModalActiveTab: activeTab,
        setShortcodeModalActiveTab: setActiveTab,
        loading,
    } = useRulesContext();

    const tabs = [
        {
            id: "basic",
            name: __(
                "Basic Settings",
                "wpbean-quantity-controls-for-woocommerce",
            ),
            icon: Settings,
        },
        {
            id: "products",
            name: __(
                "Product Settings",
                "wpbean-quantity-controls-for-woocommerce",
            ),
            icon: Package,
        },
        {
            id: "users",
            name: __(
                "User Settings",
                "wpbean-quantity-controls-for-woocommerce",
            ),
            icon: Users,
        },
    ];

    if (loading.singleShortcode) {
        return (
            <div className="bg-gray-50 border-b border-gray-200 flex items-center justify-center">
                <div className="animate-pulse space-y-2 w-full px-6 py-4">
                    <div className="h-1 bg-gray-200 rounded w-3/4"></div>
                    <div className="h-1 bg-gray-200 rounded w-3/4"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="px-4 sm:px-6 bg-gray-50 border-b border-gray-200">
            <nav
                className="flex overflow-x-auto no-scrollbar space-x-4 sm:space-x-8"
                aria-label="Tabs"
            >
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex items-center whitespace-nowrap border-b-2 py-3 px-1 text-sm font-medium transition-colors ${
                                activeTab === tab.id
                                    ? "border-blue-500 text-blue-600"
                                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                            }`}
                        >
                            <Icon className="w-4 h-4 mr-2 flex-shrink-0" />
                            {tab.name}
                        </button>
                    );
                })}
            </nav>
        </div>
    );
}
